module.exports = __webpack_public_path__ + "img/Property1RMS.c44bc040.png";